import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IColors } from '@app/core/interfaces/color.interface';

export interface IStep {
  name: string;
  progress: number;
  color?: IColors;
}

@Component({
  selector: 'ag1-stepped-progress-bar',
  templateUrl: './ag1-stepped-progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Ag1SteppedProgressBarComponent {
  @Input() steps: IStep[] = [];
  @Input() total: number = 0;

  constructor() {}

  getColor(color?: string): string {
    if (!color) {
      return '';
    }

    const colors: Record<IColors, string> = {
      red: 'bg-red-500',
      orange: 'bg-orange-500',
      amber: 'bg-amber-500',
      yellow: 'bg-yellow-500',
      lime: 'bg-lime-500',
      green: 'bg-green-500',
      emerald: 'bg-emerald-500',
      teal: 'bg-teal-500',
      cyan: 'bg-cyan-500',
      sky: 'bg-sky-500',
      blue: 'bg-blue-500',
      'french-blue': 'bg-french-blue-500',
      indigo: 'bg-indigo-500',
      violet: 'bg-violet-500',
      purple: 'bg-purple-500',
      fuchsia: 'bg-fuchsia-500',
      pink: 'bg-pink-500',
      rose: 'bg-rose-500',
      slate: 'bg-slate-500',
    };

    return colors[color] ?? '';
  }

  get currentProgress(): number {
    return this.steps?.reduce((acc, step) => acc + step.progress, 0);
  }
}
